import {Component, effect, inject, signal} from '@angular/core';
import {WaterPointSvgComponent} from "src/app/presentation/common/icons/water-point-svg/water-point-svg.component";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {
  LoadingPlaceholderComponent
} from "src/app/presentation/common/loading-placeholder/loading-placeholder.component";
import {WaterPointsStore} from 'src/app/domain/assets/water-points/water-points.store';
import {RoutingService} from 'src/app/infrastructure/routing/routing.service';
import {DeviceStore} from 'src/app/domain/devices/device.store';

@Component({
  selector: 'app-water-points-button',
  imports: [
    WaterPointSvgComponent,
    LoadingPlaceholderComponent
  ],
  templateUrl: './water-points-button.component.html',
  styleUrl: './water-points-button.component.css'
})
export class WaterPointsButtonComponent {

  loading = signal(true);

  unknown = signal(0);
  nominal = signal(0);
  warning = signal(0);
  alert = signal(0);
  unassigned = signal(0);

  private deviceStore = inject(DeviceStore);
  private waterPointsStore = inject(WaterPointsStore);

  constructor(
    protected routingService: RoutingService
  ) {
    effect(() => {
      if (this.waterPointsStore.loading() || this.deviceStore.loading()) return;

      const waterPoints = this.waterPointsStore.entities();
      const assetSamples = this.waterPointsStore.assetSamples();
      const unassignedWaterWaterMonitors = this.deviceStore.unassignedWaterMonitors();

      this.loading.set(true);

      let nominal = 0;
      let warning = 0;
      let alert = 0;
      let unknown = 0;

      waterPoints.forEach(waterPoint => {
        const samples = assetSamples.get(waterPoint);
        if (samples) {
          if (samples[0].alertStatus == undefined) {
            nominal++;
          }
          if (samples[0].alertStatus == Samples.AlertStatus.LOW_WARNING) {
            warning++;
          }
          if (samples[0].alertStatus == Samples.AlertStatus.LOW_ALERT) {
            alert++;
          }
          if (samples[0].alertStatus == Samples.AlertStatus.HIGH_WARNING) {
            warning++;
          }
          if (samples[0].alertStatus == Samples.AlertStatus.HIGH_ALERT) {
            alert++;
          }
        } else unknown++
      });

      this.nominal.set(nominal);
      this.warning.set(warning);
      this.alert.set(alert);
      this.unknown.set(unknown);
      this.unassigned.set(unassignedWaterWaterMonitors.length);

      this.loading.set(false);
    });
  }
}
